// アプリ共通定数（client/server 共有）。

export const USER_ROLES = ["admin", "school", "company"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const COMPANY_STATUSES = ["pending", "approved", "rejected"] as const;
export type CompanyStatus = (typeof COMPANY_STATUSES)[number];

export const APPLICATION_STATUSES = ["applied", "approved", "rejected", "cancelled"] as const;
export type ApplicationStatus = (typeof APPLICATION_STATUSES)[number];

// 業種マスタの「迷ったときの受け皿」。必ず1件残す（§2.4「other を必ず置く」）。
// 廃止・統合元にできない（サーバで拒否）。ダッシュボードの割合監視の対象でもある。
export const FALLBACK_INDUSTRY_CODE = "other";

// 一覧の既定・上限（[19] §1.5）
export const PAGE_DEFAULT = 1;
export const LIMIT_DEFAULT = 20;
export const LIMIT_MAX = 100;

// 地図（§2.6）。全体地図のピン上限（超過は先頭N件＋絞り込み案内）と半径検索の上限km。
export const MAP_MAX_PINS = 500;
export const RADIUS_KM_MAX = 30;
// 半径検索で矩形候補を取得する際の安全上限（超過はログ・町規模では非到達）。
export const RADIUS_CANDIDATE_CAP = 2000;

// 一括申込（F-06b・§4.3）。1リクエストで申し込める上限社数。
export const BULK_MAX_ITEMS = 50;

// 通知の未達検知（§5）。企業へ「未通知」と見なす猶予（リトライ窓を包含して15分）。
// サービス側の判定と管理ダッシュボードの集計で同一値を使う（ズレ防止）。
export const NOTIFY_GRACE_MS = 15 * 60 * 1000;
// 再送のクールダウン（申込単位）。障害中の連打＝企業へのメール爆撃を防ぐ。
export const RENOTIFY_COOLDOWN_MS = 5 * 60 * 1000;

// アップロード等の将来用（[19] §6.4）。現時点でファイルアップロードは無し。
export const MAX_TEXT_SHORT = 200;
export const MAX_TEXT_LONG = 2000;

// エラーコード（SCREAMING_SNAKE。フロントはこの値で分岐・[19] §1.3）
export const ERROR_CODES = {
  VALIDATION_ERROR: "VALIDATION_ERROR",
  UNAUTHENTICATED: "UNAUTHENTICATED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  APPLICATION_ALREADY_DECIDED: "APPLICATION_ALREADY_DECIDED",
  APPLICATION_ALREADY_NOTIFIED: "APPLICATION_ALREADY_NOTIFIED",
  DUPLICATE_APPLICATION: "DUPLICATE_APPLICATION",
  COMPANY_NOT_AVAILABLE: "COMPANY_NOT_AVAILABLE",
  BUSINESS_RULE_VIOLATION: "BUSINESS_RULE_VIOLATION",
  RATE_LIMITED: "RATE_LIMITED",
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
  INTERNAL_ERROR: "INTERNAL_ERROR",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
